module Sxc.Site {
    export class RoomView {
        private roomlist;
        public roomgallery;

        constructor(roomlist) {
            this.roomlist=roomlist;
            this.roomgallery=new RoomGallery((roomlist));
        }

        /**
         * Megnyitja a szobát nagyban
         */
        private lastscrolltop=0;
        private pophandler=null;
        private marker_for_hide_chat_if_needed=false;
        private marker_for_hide_chat_if_needed_tu=-1;
        private last_opened_room=null;
        public current_performer_data=[];
        _openPerformerFullscreen(roomData) {
            let thisref=this;

            //show loading if mobile
            if(window['chatClient'].app.isMobileView()){
                $(".content-loading-roomlist").show();
                $(".content-loading-roomlist:not(.chat-show)").addClass("chat-show");
            }

            try{clearInterval(thisref.roomlist.focuser);}catch (e) { }
            this.lastscrolltop=$(document).scrollTop();

            try{clearTimeout(thisref.marker_for_hide_chat_if_needed_tu);}catch (e) {}
            thisref.marker_for_hide_chat_if_needed=true;
            // @ts-ignore
            thisref.marker_for_hide_chat_if_needed_tu=setTimeout(function () {thisref.marker_for_hide_chat_if_needed=false;},5000);

            //close button
            $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").off("click");
            $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").click(function(){thisref._closeChatFuncOpenedRoom();});
            $(window).off('popstate');
            this.pophandler=$(window).on('popstate', function(event) {
                if(window.location.href.indexOf("#")!==-1){
                    window.history.pushState("", "", window.location.href.replace("#",""));
                    return;
                }
                if(!$(".fancybox-container").is(":visible")){
                    thisref._closePerformerFullscreen();
                    if(window.location.href.indexOf("/mypage/")!==-1){window.history.replaceState("", "", '/live');}
                }
            });

            //státusz aktuális lekérdezés
            let perfid="";
            if(typeof roomData ==="undefined" || roomData== null){
                let arr1=window.location.href.split("/mypage/");
                let arr2=arr1[1].split("/");
                perfid=arr2[0];perfid=(arr2[0].split("?"))[0];
                //roomData={perfid:perfid};
            }
            else{perfid=roomData.perfid;}
            this.last_opened_room=perfid;

            $.ajax({  url: '/ajax/api/roomList/babes-get-profile?perfid='+perfid+'&extended=1', dataType: 'json',
                complete:function(){
                    //loading screen eltüntetése (ha konkrét szobára érkezett)
                    $(".content-loading-roomlist:not(.chat-show)").hide();
                }
            }).done((dataJson) => {
                thisref.current_performer_data=dataJson;

                //design módosítás
                $("section.onlineroom-section,body > footer ,.chatroomcont,#header").hide();
                $("#frame_chat-app,.chatroomcont").addClass("frame_chat-app-fullscreen").addClass("isloading");
                $("#frame_chat-app .frame-content").addClass("frame_chat-app-frame-content-fullscreen");
                $(".sxcc-close-chat").addClass("fullscreen-babes");
                $(".sxcc-tip-after-show-wrapper").hide();
                if((perfid+"").indexOf("v") !==-1){
                    $(".sxc-chat").addClass("isvisitx");
                }else{
                    $(".sxc-chat").removeClass("isvisitx");
                }

                //extended chat template
                if( typeof dataJson["extendedChatTemplate"] !=="undefined" && dataJson["extendedChatTemplate"] !==""){
                    $("#frame_chat-app #chatTemplateExtender").remove();
                    $("#frame_chat-app .sxc-chat:first").prepend('<div id="chatTemplateExtender"></div>');
                    $("#frame_chat-app #chatTemplateExtender").html(dataJson["extendedChatTemplate"]);
                }

                if(typeof dataJson["onlinestatus"]!== "undefined"){
                    if(dataJson["onlinestatus"]=="offline" && dataJson["roomMode"]!="pause"){
                        $(".sxcc-toast-wrapper").hide();
                        $(".sxcc-toast-wrapper").removeClass("sxc-visible");
                        setTimeout(function () { $(".sxcc-toast-wrapper").show();   },2000);

                        thisref.mypageHideTopChat();
                        thisref.showTeaser();
                    }
                    else if(!$(".sxcc-wrapper").hasClass("hiddenchat")){thisref.mypageShowTopChat();}
                }else{
                    //ha inakítv
                    this._closePerformerFullscreen();
                    return;
                }

                //join
                if(typeof roomData ==="undefined" || roomData== null){//konkrét szobára érkezés esetén
                    window['chatClient'].app.allownextroom=false;
                    window['chatClient'].app.options.chatIncludeType="babesIFrameFullscreen";
                    window['chatClient'].app.showRoom(perfid/*, roomData.screenname, roomData.roomimgid, {}*/);
                    //setTimeout(() => {  thisref.addUserDataFrame(perfid);}, 1);
                    thisref.openroomdesignfix();
                } else {
                    window['chatClient'].app.reset(() => {
                        if(roomData.onlinestatus == 'offline') { window['chatClient'].app.allownextroom=false; }

                        window['chatClient'].app.options.chatIncludeType="babesIFrameFullscreen";
                        //window['chatClient'].app.view.setSize("normal");

                        window['chatClient'].app.showRoom(roomData.perfid/*, roomData.screenname, roomData.roomimgid, {}*/);
                        //setTimeout(() => {  thisref.addUserDataFrame(roomData.perfid);}, 1);

                        thisref.openroomdesignfix();
                    });
                }

                //show reg popup if needed
                if(window.location.href.indexOf("showreg=1") !== -1) {
                    thisref.roomlist.babesHandler.showPopup('regpop',dataJson["profilePic"],"arrived", null);
                }
            });

            //streamek leállítása a szobalistában
           this.stopStreamPreviews();

            //scroll to top
            $('html, body').animate({ scrollTop:0}, 1);

            $(window).trigger("resize");

            //fix scrollbug after aarriving from email confirm
            $("#stripMessage").prependTo(".sxc-chat:first");

            this.askPushNotificationPermissionIfNeeded();
        }

        stopStreamPreviews(){
            let thisref = this;
            $("#roomlist .room-item").each(function () {
                thisref.roomlist.helpers.log("tryleave0 _openPerformerFullscreen:"+$(this).data('perfid'));
                thisref.roomlist._bindStreamPreviewLeave($(this).data('perfid'),true);
                $(this).removeClass("asready");
                $(this).removeClass("autostart");
            });
        }

        // Needed for new browsers but same user
        notif_key_already_asked=false;
        askPushNotificationPermissionIfNeeded(){
            if(!this.roomlist.mypage_loaded_first){
                // @ts-ignore
                if(!this.notif_key_already_asked && (window.__webpushisactive==='1' || window.__fanclubpushisactive==='1')){
                    // @ts-ignore
                    notificationPopup.send();
                    this.notif_key_already_asked=true;
                }
            }
        }

        /**
         * openRoomdesignfix
         */
        openroomdesignfix(){
            let thisref=this;
            $("button[data-action='resize']").click(function(){
                setTimeout(function () { thisref.openroomdesignfix_set(); },100);
            });
            setTimeout(function () { thisref.openroomdesignfix_set(); },100);
        }
        async openroomdesignfix_set(){
            $(window).resize();
            for(let i=0;i<6;i++){
                await new Promise( resolve => setTimeout(resolve, 500) );
                window['chatClient'].app.view.onWindowResize();
            }
        }

        /**
         * Bezárja és kinyitja a szobát
         */
        _openclosePerformerFullscreen() {
            /*this._closePerformerFullscreen(true,true);
            this._openPerformerFullscreen({"perfid":this.last_opened_room,"screenname":"","roomimgid":""});*/
            window['chatClient'].app.event.trigger("roomHistoryChanged");
        }

        /**
         * Bezárja a szobát
         */
        _closePerformerFullscreen(autojoin=true,do_not_close_fanclub=false) {
            let thisref=this;

            //design módosítás
            $("section.onlineroom-section,body > footer,#header").show();
            $("#frame_chat-app,.chatroomcont").removeClass("frame_chat-app-fullscreen");
            $("#frame_chat-app .frame-content").removeClass("frame_chat-app-frame-content-fullscreen");
            $(".sxcc-close-chat").removeClass("fullscreen-babes");
            this.mypageShowTopChat();
            $("title").text(this.roomlist.mainpagetitle);
            $("#video-player-teaser-cont").html("");
            $(".sxcc-wrapper").removeClass("teaseron");

            //meta adat módosítás
            $("#meta_title").attr("content",  $("#meta_title").attr("content-old"));
            $("#meta_og_description").attr("content",  $("#meta_og_description").attr("content-old"));
            $("#meta_description").attr("content",  $("#meta_description").attr("content-old"));
            $("#meta_image").attr("content",  $("#meta_image").attr("content-old"));

            // extender templte remove
            $("#frame_chat-app #chatTemplateExtender").remove();

            //előző pozícióra scroll
            $('html, body').animate({ scrollTop:this.lastscrolltop}, 1);

            if(window.location.href.indexOf("/mypage/")!==-1){window.history.replaceState("", "", '/live');}

            // hides Fan Club panel
            if (window.sxc && window.sxc.fanclub && !do_not_close_fanclub) {
                window.sxc.fanclub.panel.hide();
            }

            $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").off("click");
            $("#frame_chat-app .sxcc-stream-wrapper button[data-action='close']").click(function(){thisref._closeChatFuncRoomlist();});

            //ha valamely oknál fogva nincsenek szobák (néha előjött)
            if($("#roomlist li:visible").length<10){$('.roomlist-paging').trigger('click');}

            //roomlista frissítése, ha kell promo miatt
            // @ts-ignore
            /*if($("#roomlist li.happy-hour-promo").length==0 && securionPayHandler.promo.promo!=null){
                //this._loadRoomList(false,true);
            }*/
            if(new Date().getTime() -this.roomlist.lastrefreshed_ts>this.roomlist.roomlist_auto_refresh_seconds*1000){
                this.roomlist._loadRoomList(true,true);
            }else{
                //streamek elindítása a szobalistában
                this.roomlist._StartStreamsRandom();
            }

            //join
            //if(!this.topchatvisibleinroomlist){
                window['chatClient'].app.reset();
                $("#frame_chat-app").show();//topup miatt kell
            /*}else{
                window['chatClient'].app.reset(() => {
                    if (autojoin) {
                        if ($(".chatroomcont").attr("data-closed") != "true") {
                            $(".chatroomcont").show();
                            window['chatClient'].app.allownextroom = true;
                            window['chatClient'].app.options.chatIncludeType = "babesIFrame";
                            window['chatClient'].app.view.setSize("normal");
                            thisref.joinRandomRoom();
                        } else {
                            window['chatClient'].app.close();
                            $("#frame_chat-app").show();//topup miatt kell
                        }
                    }
                });
            }*/

            //Fix alert bug for mute
            $(".sxcc-toast-wrapper").removeClass("sxc-visible");

            //hide chat interface
            if(!$("#frame_chat-app").hasClass("frame_chat-app-fullscreen")){
                window['chatClient'].app.view.hideChatInterface(true);
                setTimeout(function () {   window['chatClient'].app.view.hideChatInterface(true);}, 150);
                setTimeout(function () {   window['chatClient'].app.view.hideChatInterface(true);}, 300);
            }

            $("html").css("overflow","");
            this.roomlist.mypage_loaded_first=false;

            this.roomgallery.destroyLovense();
        }

        /**
         * Chat bezárási múvelet megnyitott szoba esetén
         */
        public _closeChatFuncOpenedRoom(event=null,autojoin=true,fromeesckey=false){
            if(event!=null){
                event.preventDefault();
                event.stopImmediatePropagation(); //ez állítja meg a többi bind futást
            }
            if($(".sxcc-cam2cam").is(":visible")){
                window["chatClient"].app.view.cam2cam.leave();
                if(!fromeesckey){return;}
            }

            if(!$(".sxc-chat").hasClass("sxcc-size-fs") || window['chatClient'].app.isMobileView()){
                if($(".sxc-chat").hasClass("sxcc-size-fs") && window['chatClient'].app.isMobileView() ){window['chatClient'].app.view.setSize("normal");}
                this._closePerformerFullscreen(autojoin);
                $(".sxcc-obj-wrapper").removeClass("sxccs-float-over-reg");
            }else{
                window['chatClient'].app.view.setSize(window['chatClient'].app.view.prevSize);
            }
        }


        /**
         * Rendom szobára join
         */
        public joinRandomRoom(){
            let thisref=this;

            $.ajax({
                url      : '/ajax/api/roomList/babes-get-random',
                type     : 'GET',
                dataType : 'json',
                data     : {}
            }).done((responseJSON) => {
                if(responseJSON.length>1  && (typeof window['chatClient'].app.chatServer.currentRoom !=="undefined" && window['chatClient'].app.chatServer.currentRoom != null &&  responseJSON.indexOf(window['chatClient'].app.chatServer.currentRoom.roomID)!==-1  )){
                    let index = responseJSON.indexOf(window['chatClient'].app.chatServer.currentRoom.roomID);
                    responseJSON.splice(index, 1);
                }
                thisref.roomlist.lastRandomFreeRoom={"roomid":responseJSON[0]};
                window['chatClient'].app.reset(() => {
                    window['chatClient'].app.view.setSize("normal");
                    window['chatClient'].app.showRoom(thisref.roomlist.lastRandomFreeRoom==null?51162:thisref.roomlist.lastRandomFreeRoom.roomid/*,  'param-screenName', 'param-profilePic', {}*/);
                    if(thisref.roomlist.lastRandomFreeRoom!=null){
                        thisref.roomlist.helpers.log("tryleave0 joinRandomRoom:"+thisref.roomlist.lastRandomFreeRoom.roomid);
                        thisref.roomlist._bindStreamPreviewLeave(thisref.roomlist.lastRandomFreeRoom.roomid);
                    }
                });
            });


        }

        /**
         * Mypage top chat elrejtése
         */
        public mypageHideTopChat(reset=false) {
            let thisref = this;
            $(".sxcc-wrapper").addClass("hiddenchat");
            if(reset){
                window['chatClient'].app.reset(() => {
                    // @ts-ignore
                    let room= thisref.helpers.getCurrentRoomidFromChat();
                    window['chatClient'].app.options.chatIncludeType="babesIFrameFullscreen";
                    window['chatClient'].app.showRoom(room);
                });
            }
        }

        public showTeaser(){
            let thiserf=this;
            if($(".sxcc-wrapper").hasClass("hiddenchat") && typeof $("#frame_chat-app .performercontent .mediagallery").attr("data-teaser") !=="undefined" && typeof $("#frame_chat-app #sxcc-obj-video").attr("src") ==="undefined"){//ha van teaser videója
                $.ajax({
                    url: 'https://videoman.a.apn2.com/api/videoPlayer/video/'+$("#frame_chat-app .performercontent .mediagallery").attr("data-teaser")+'?tokenID='+window["chatClient"].app.options.auth.tokenID,
                    dataType: 'json'
                }).done((videoData) => {
                    if(videoData.status != 402 ) {
                        if(shaka.Player.isBrowserSupported() && typeof videoData.drm!=="undefined" && !thiserf.roomlist.helpers.isiOS()){
                            $("#video-player-teaser-cont").html("").append('<video id="video-player-teaser" controls="controls" controlsList="nodownload" oncontextmenu="return false;" autoplay="autoplay" playsinline="playsinline" src=""></video>');
                            thiserf.roomlist.videoPlayer.playVideoWithDashOrHls(videoData.drm,window["chatClient"].app.options.auth.tokenID,$("#video-player-teaser")[0],thiserf.roomlist.shakaPlayerTeaser,videoData.url);
                        }else {
                            $("#video-player-teaser-cont").html("").append('<video id="video-player-teaser" controls="controls" controlsList="nodownload" oncontextmenu="return false;" autoplay="autoplay" playsinline="playsinline" src="' + videoData.url + '"></video>');
                        }
                        $(".sxcc-wrapper").addClass("teaseron");
                    }
                });
            }else{
                $(".sxcc-wrapper").removeClass("teaseron");
                $("#video-player-teaser").remove();
            }
        }

        /**
         *
         *
         */
        public mypageShowTopChat() {
            $(".sxcc-wrapper").removeClass("hiddenchat");
            $("#video-player-teaser-cont").html("");
            $(".frame-content > .frame-paging").appendTo(".frame-content .sxc-chat"); //Bal, Jobb szobaváltó pozícionálás

            //Utólagos ellenőrzés, hogy tényleg nem offline-e a szoba
            /*if(window.location.href.indexOf("/mypage/")!==-1){
                let arr1=window.location.href.split("/mypage/");let arr2=arr1[1].split("/");let perfid=(arr2[0].split("?"))[0];
                $.ajax({  url: '/ajax/api/roomList/babes-get-profile?perfid='+perfid, dataType: 'json'}).done((dataJson) => {
                    if(typeof dataJson["onlinestatus"]!== "undefined"){
                        if(dataJson["onlinestatus"]=="offline" && dataJson["roomMode"]!="pause"){
                            $(".sxcc-toast-wrapper").hide();
                            $(".sxcc-toast-wrapper").removeClass("sxc-visible");
                            setTimeout(function () { $(".sxcc-toast-wrapper").show();   },2000);
                            this.mypageHideTopChat();
                            window['chatClient'].app.allownextroom=false;
                        }
                    }
                });
            }*/
        }


        /**
         * Chat bezárási múvelet
         */
        public _closeChatFuncRoomlist(event=null){
            if(event!=null){
                event.preventDefault();
                event.stopImmediatePropagation(); //ez állítja meg a többi bind futást
            }
            $(".chatroomcont").hide();
            $(".chatroomcont").attr("data-closed","true");
            window["chatClient"].app.close();
            $("#frame_chat-app").show();//topup miatt kell
            $(".sxcc-obj-wrapper").removeClass("sxccs-float-over-reg");
        }

        /* Chat template extender: Zizgő küldés */
        public extend_chat_send_zzz(){
            $('.sxccp-smarttips-wrapper .send').click();
        }

        /* Chat template extender: Fix összegű Zizgő küldés */
        public extend_chat_send_fix_zzz(amount){
            window["chatClient"].app.view.specialGiftPanel.onSmartZzzSend(amount)
        }

        /* Chat template extender: Chat üzenet küldés */
        public extend_chat_send_chat_msg(msg){
            $("#lp-message-search").val(msg);
            $("#lp-disable-search button[data-action='send']").click();
        }

        /* Chat template extender: Emoji küldés */
        public extend_chat_send_emoji(emoji:string){
            $('.sxc-emoji[data-sxc-u=\''+emoji+'\']').click();
        }

        /* Chat template extender: Tip küldés */
        public extend_chat_send_tip_popup(tip_id:string,tip_price:string){
            $("#profile_gifts").click();
            // @ts-ignore
            closeBabesGiftsPopup()
            $('.babes-gifts-search-results [data-id=\''+tip_id+'\'][data-price=\''+tip_price+'\']').click();
        }

        /* Chat template extender: Tip küldés */
        public extend_chat_send_gift_popup(gift_id:string){
            $("#profile_gifts").click();
            // @ts-ignore
            closeBabesGiftsPopup()
            $('.babes-gifts-search-results [data-id=\''+gift_id+'\']').click();
        }

        /* Chat template extender: Tip küldés instant */
        public extend_chat_send_tip_instant(tip_id:string,tip_price:string){
            $(".sxccb-button.sxccc-gift").click();$(".sxccb-button.sxccc-gift").click();
            // @ts-ignore
            window.chatClient.app.view.giftPanel.showGift(tip_id,tip_price);
        }

        /* Chat template extender: Ajándék küldés instant */
        public extend_chat_send_gift_instant(gift_id:string){
            $(".sxccb-button.sxccc-gift").click();$(".sxccb-button.sxccc-gift").click();
            // @ts-ignore
            window.chatClient.app.view.giftPanel.showGift(gift_id,$('.sxcg-gift-item[data-id=\''+gift_id+'\']').attr('data-price'));
        }
    }
}